import React, { PropsWithoutRef } from 'react'
import styled from '@emotion/styled'

import ExternalSvg from '../images/icon-external.svg'

const StyledButton = styled.a`
  align-items: center;
  background: var(--color-ground-1000);
  border: 1px solid var(--color-figure-0100);
  color: inherit;
  display: flex;
  font-size: var(--font-size-s1);
  justify-content: space-between;
  letter-spacing: 0.1em;
  padding: 0.75em 1.25em;
  text-decoration: none;
  transition-duration: 0.5s;
  transition-property: background-color, border-color, color;
  white-space: nowrap;

  svg {
    height: auto;
    width: 1em;
  }

  svg path {
    fill: var(--color-figure-0500);
    transition: fill 0.5s;
  }

  &:active {
    background-color: var(--color-figure-1000);
    border-color: var(--color-figure-1000);
    color: var(--color-ground-1000);

    svg path {
      fill: var(--color-ground-0500);
      transition-duration: 0.2s;
    }
  }

  @media (hover: hover) {
    &:hover {
      background-color: var(--color-figure-1000);
      border-color: var(--color-figure-1000);
      color: var(--color-ground-1000);
      transition-duration: 0.2s;

      svg path {
        fill: var(--color-ground-0500);
        transition-duration: 0.2s;
      }
    }
  }
`

type ButtonProps = PropsWithoutRef<JSX.IntrinsicElements['a']>

export const Button: React.FC<ButtonProps> = ({ children, href, ...props }) => (
  <StyledButton href={href} {...props}>
    <span>{children}</span>
    {href?.startsWith('http://') ||
    href?.startsWith('https://') ||
    href?.startsWith('//') ? (
      <ExternalSvg />
    ) : null}
  </StyledButton>
)
